import { render, staticRenderFns } from "./AddEditSidebar.vue?vue&type=template&id=33aa9c14&scoped=true"
import script from "./AddEditSidebar.vue?vue&type=script&lang=js"
export * from "./AddEditSidebar.vue?vue&type=script&lang=js"
import style0 from "./AddEditSidebar.vue?vue&type=style&index=0&id=33aa9c14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aa9c14",
  null
  
)

export default component.exports